import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import conversationReducer from './slices/conversationSlice';
import masterDataReducer from './slices/masterDataSlice';
import { authMiddleware, initializeAuth } from './middleware/auth-middleware';

// Initialize auth on store creation
initializeAuth();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    conversation: conversationReducer,
    masterData: masterDataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;